import React from 'react';
import { Tabs } from '@mui/material';

/**
 * MUI Tabs whose underline stays correct under `body { zoom: 0.8 }` (src/assets/styles/main.css).
 * MUI's sliding indicator is positioned from measured tab sizes, which the browser reports in zoomed pixels, so
 * under zoom it lands short and to the left. This hides that indicator and draws the line on the selected tab
 * itself (a ::after bar), which is exact at any zoom. Use it in place of <Tabs>; the props are the same, plus:
 *  - indicatorColor: CSS color of the line (default: the theme primary color).
 *  - indicatorHeight: line thickness in px (default 3).
 */
const ZoomSafeTabs = React.forwardRef(({
  indicatorColor = 'primary.main',
  indicatorHeight = 3,
  TabIndicatorProps,
  sx,
  ...props
}, ref) => (
  <Tabs
    ref={ref}
    {...props}
    TabIndicatorProps={{ ...TabIndicatorProps, sx: { ...(TabIndicatorProps && TabIndicatorProps.sx), display: 'none' } }}
    sx={[
      {
        '& .MuiTab-root': { position: 'relative' },
        '& .MuiTab-root.Mui-selected::after': {
          content: '""',
          position: 'absolute',
          left: 0,
          right: 0,
          bottom: 0,
          height: indicatorHeight,
          borderRadius: `${indicatorHeight}px ${indicatorHeight}px 0 0`,
          bgcolor: indicatorColor
        }
      },
      ...(Array.isArray(sx) ? sx : [sx])
    ]}
  />
));

ZoomSafeTabs.displayName = 'ZoomSafeTabs';

export default ZoomSafeTabs;
